/* eslint-disable */
import * as Types from "./types";

import { TypedDocumentNode as DocumentNode } from "@graphql-typed-document-node/core";
export type GqlGroupsQueryVariables = Types.Exact<{
  formUri: Types.Scalars["ID"]["input"];
  sectionUri?: Types.InputMaybe<Types.Scalars["ID"]["input"]>;
  submissionUri?: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  usePublishedVersion?: Types.InputMaybe<Types.Scalars["Boolean"]["input"]>;
}>;

export type GqlGroupsQuery = {
  __typename: "Query";
  groups: Array<{
    __typename: "Group";
    uri: string;
    values: {
      __typename: "GroupValues";
      uri: string;
      formUri: string;
      sectionUri: string;
      operationId: string;
      deleted?: boolean | null;
      order: string;
      label?: string | null;
      hint?: string | null;
      description?: string | null;
      type: Types.GqlGroupType;
      templateType?: Types.GqlGroupTemplateType | null;
      repeatable?: boolean | null;
      repeatPrompt?: string | null;
      minRepeat?: number | null;
      maxRepeat?: number | null;
      updatedAt: string;
      allowedRepeatable?: boolean | null;
      layout?: {
        __typename: "MatterLayout";
        id: string;
        providerId: string;
        name: string;
        parentId?: string | null;
        parentName?: string | null;
        parentProviderId?: string | null;
        displayName?: string | null;
      } | null;
      field?: {
        __typename: "MatterField";
        name: string;
        type: string;
        possibleValues?: Array<string> | null;
        dataSourceMapping?: string | null;
        displayName?: string | null;
        details?: string | null;
        originalName?: string | null;
      } | null;
      links?: Array<{
        __typename: "FieldLink";
        fieldUri: string;
        condition: Types.GqlLinkCondition;
        value: string;
        hide?: boolean | null;
      }> | null;
      translations?: Array<{
        __typename: "GroupTranslation";
        language: string;
        label?: string | null;
        description?: string | null;
        repeatPrompt?: string | null;
      }> | null;
    };
  }>;
};

export const GroupsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "groups" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "formUri" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "sectionUri" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "submissionUri" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "usePublishedVersion" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "groups" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "formUri" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "formUri" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "sectionUri" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "sectionUri" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "submissionUri" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "submissionUri" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "usePublishedVersion" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "usePublishedVersion" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "groupFields" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "groupFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Group" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "uri" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "values" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "uri" } },
                { kind: "Field", name: { kind: "Name", value: "formUri" } },
                { kind: "Field", name: { kind: "Name", value: "sectionUri" } },
                { kind: "Field", name: { kind: "Name", value: "operationId" } },
                { kind: "Field", name: { kind: "Name", value: "deleted" } },
                { kind: "Field", name: { kind: "Name", value: "order" } },
                { kind: "Field", name: { kind: "Name", value: "label" } },
                { kind: "Field", name: { kind: "Name", value: "hint" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "templateType" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "layout" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "providerId" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "parentId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "parentName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "parentProviderId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayName" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "field" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "possibleValues" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "dataSourceMapping" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "details" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "originalName" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "links" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "fieldUri" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "condition" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                      { kind: "Field", name: { kind: "Name", value: "hide" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "repeatable" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "repeatPrompt" },
                },
                { kind: "Field", name: { kind: "Name", value: "minRepeat" } },
                { kind: "Field", name: { kind: "Name", value: "maxRepeat" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "allowedRepeatable" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "translations" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "language" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "description" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "repeatPrompt" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GqlGroupsQuery, GqlGroupsQueryVariables>;
